module.exports = __webpack_public_path__ + "static/media/049.ac0f3f1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/049.jpg
// module id = 394
// module chunks = 0